import { useEffect } from 'react';
import Lenis from 'lenis';

export default function LenisScroll() {
  useEffect(() => {
    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const coarsePointerQuery = window.matchMedia('(pointer: coarse)');
    const mobileWidthQuery = window.matchMedia('(max-width: 1023px)');

    let lenis = null;
    let rafHandle = 0;
    const clearScrollLocks = () => {
      const html = document.documentElement;
      const body = document.body;
      const lockClasses = ['lenis', 'lenis-smooth', 'lenis-stopped'];
      lockClasses.forEach((cls) => {
        html.classList.remove(cls);
        body.classList.remove(cls);
      });
      html.style.removeProperty('overflow');
      html.style.removeProperty('overflow-y');
      html.style.removeProperty('height');
      body.style.removeProperty('overflow');
      body.style.removeProperty('overflow-y');
      body.style.removeProperty('height');
    };

    const destroyLenis = () => {
      if (rafHandle) {
        cancelAnimationFrame(rafHandle);
        rafHandle = 0;
      }
      if (lenis) {
        lenis.destroy();
        lenis = null;
      }
      delete window.__lenis;
      clearScrollLocks();
    };

    const createLenis = () => {
      lenis = new Lenis({
        duration: 1.1,
        smoothWheel: true,
        smoothTouch: false,
        anchors: true,
      });
      window.__lenis = lenis;
      const raf = (time) => {
        if (!lenis) return;
        lenis.raf(time);
        rafHandle = requestAnimationFrame(raf);
      };
      rafHandle = requestAnimationFrame(raf);
    };

    const shouldEnableLenis = () => {
      if (reduceMotionQuery.matches) return false;
      if (coarsePointerQuery.matches) return false;
      if (mobileWidthQuery.matches) return false;
      return true;
    };

    const syncLenisMode = () => {
      if (shouldEnableLenis()) {
        if (!lenis) {
          createLenis();
        }
        return;
      }
      destroyLenis();
    };

    const subscribeQuery = (query, handler) => {
      if (typeof query.addEventListener === 'function') {
        query.addEventListener('change', handler);
        return () => query.removeEventListener('change', handler);
      }
      if (typeof query.addListener === 'function') {
        query.addListener(handler);
        return () => query.removeListener(handler);
      }
      return () => {};
    };

    syncLenisMode();
    window.addEventListener('resize', syncLenisMode);
    const unbindReduce = subscribeQuery(reduceMotionQuery, syncLenisMode);
    const unbindPointer = subscribeQuery(coarsePointerQuery, syncLenisMode);
    const unbindWidth = subscribeQuery(mobileWidthQuery, syncLenisMode);

    return () => {
      window.removeEventListener('resize', syncLenisMode);
      unbindReduce();
      unbindPointer();
      unbindWidth();
      destroyLenis();
    };
  }, []);

  return null;
}
